module.exports = __webpack_public_path__ + "present1.png?64603c125049acffd1a4913a50e80e32";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/present1.png
// module id = 130
// module chunks = 0